import { PageHero } from '@scrippsproduct/scripps-external-component-library'
import Schedule from '../components/Schedule'
import FindUs from '../components/FindUs'


function Home() {
    // const { isSuccess, isLoading, isError, data: affiliates } = useQuery([`affiliates`, {resourceName: 'affiliates',}], getAffiliates)
    // const { isSuccess: isSuccessPlatforms, data: platforms } = useQuery([`platforms`, {resourceName: 'platforms',}], getPlatforms)

    return (<>
        <PageHero layoutComponent='ContentHero' layoutProps={{
            fullSizeImage: {
                url: 'https://ewscripps.brightspotcdn.com/41/93/107df0b14fa1bd7ebe1ea87df933/24-mys-1511168949digital-web-ion-mystery-landing-page-image-3000x2000.jpg',
                dimensions: {
                    width: 3000,
                    height: 2000
                }
            },
            fullSizeImageMobile: {
                url: 'https://ewscripps.brightspotcdn.com/41/93/107df0b14fa1bd7ebe1ea87df933/24-mys-1511168949digital-web-ion-mystery-landing-page-image-3000x2000.jpg',
                dimensions: {
                    width: 3000,
                    height: 2000
                }
            },
            fullSizeImagePosition: [0, 0],
            fullSizeImageMobilePosition: [50, 50],
        }}>
            <img src="https://ewscripps.brightspotcdn.com/e3/aa/13379eff448895256e2241cb8c5d/logo-ion-mystery-2024-2x.png" alt="ION Mystery logo" className='hero-logo' width="300" height="119" />
            <p>
                ION Mystery invites you to join the investigation every day of the week, with edge-of-your-seat thrillers that will keep you guessing until the very end.
            </p>
        </PageHero>
        <div className='mobile-hero-description'>
            <p>ION Mystery invites you to join the investigation every day of the week, with edge-of-your-seat thrillers that will keep you guessing until the very end.</p>
        </div>
        <div id="schedule">
            <Schedule />
        </div>
        <div id="find-us">
            <FindUs />
        </div>
        {/*  */}
        {/* <Schedule /> */}
        {/* <h2 className='section-header' id="find-us">Find ION Mystery</h2> */}
        {/* {isLoading && <div style={{'height': '30rem'}}><Working /></div>} */}
        {/* {isError && <div className="constrain-content">We're sorry we aren't able to find our station data right now. Please check back soon.</div>} */}
        {/* {isSuccess &&             
            <FindUs 
                affiliates={affiliates} 
                network={'ION Mystery'} 
                hideSelectOnResults={false}
                autoScrollOffset={0}
            />
        } */}
        {/* {isSuccessPlatforms && <ViewingPlatforms platforms={platforms} />} */}
    </>)
}

export default Home